module.exports = __webpack_public_path__ + "img/save-time.b11e4e75.png";